<div
  class="offer-slide-out"
  [@slideInOut]="slideOutAnimationState()"
  role="dialog"
  aria-labelledby="slideOutTitle"
  [attr.aria-describedby]="description() ? 'slideOutDescription' : null"
>
  <div>
    <section
      class="offer-slide-out__inner"
      tabindex="-1"
      cdkTrapFocus
      (keydown.esc)="closeSlideOut.emit()"
      #sidebar
    >
      <div class="offer-slide-out__content">
        <header class="mb-6">
          <div class="mb-3 flex justify-between gap-4">
            <h4 class="heading-s-bold md:heading-m-bold text-navy-900" id="slideOutTitle">
              {{ title() }}
            </h4>
            <button
              (click)="closeSlideOut.emit()"
              class="relative -top-2 md:-top-4 md:-right-4 flex h-full"
              aria-label="close dialog"
              #closeBtnRef
            >
              <app-icon-close
                width="20"
                height="20"
                color="#36445E"
              ></app-icon-close>
            </button>
          </div>
          @if (description()) {
          <p class="be-body-s-bold md:be-body-m-bold text-navy-800" id="slideOutDescription">
            {{ description() }}
          </p>
          }
        </header>
        <ng-content></ng-content>
      </div>
      <ng-content select="[slideOutFooter]"></ng-content>
    </section>
  </div>
</div>
